import { useEffect } from 'react'
import { APP_NAME } from '@/lib/document-title'

/**
 * Sets `document.title` to the given value (already suffixed — build it with
 * `resolveDocumentTitle` / `formatDocumentTitle`). Empty falls back to the app name.
 *
 * Single-owner by design: only one caller per rendered tree. Child effects run
 * before parent effects in React, so two callers in the same tree would let the
 * ancestor silently win. The authenticated shell's owner is `<DocumentTitle />`.
 */
export function useDocumentTitle(title: string | null | undefined): void {
  useEffect(() => {
    document.title = title?.trim() || APP_NAME
  }, [title])
}
